/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { makeStyles } from "../../packages/fluent9";

/**
 * Gets the styles for the Grid component.
 * @returns The styles for the Grid component.
 */
export const useStyles = makeStyles({
    grid: {
        boxSizing: "border-box",
        display: "grid",
        height: "auto",
        width: "auto"
    }
});
